import { generateId } from '@freelancer/datastore/testing/helpers';
import type {
  SupportArticle,
  SupportRelatedArticle,
} from './support-articles.model';

export interface GenerateSupportArticleOptions {
  readonly id?: number;
  readonly title?: string;
  readonly content?: string;
  readonly seoUrl?: string;
  readonly relatedArticles?: readonly SupportRelatedArticle[];
  readonly isPositiveFeedback?: boolean;
  readonly categoryName?: string;
}

export function generateSupportArticleObject({
  id = generateId(),
  title,
  content,
  seoUrl,
  relatedArticles = [],
  isPositiveFeedback,
  categoryName = 'General',
}: GenerateSupportArticleOptions): SupportArticle {
  return {
    id,
    title: title ?? `Article ${id}`,
    content: content ?? `Content for article ${id}`,
    seoUrl: seoUrl ?? `article-${id}`,
    relatedArticles,
    isPositiveFeedback,
    categoryName,
  };
}

export function generateSupportArticleObjects(
  articles: readonly GenerateSupportArticleOptions[],
): readonly SupportArticle[] {
  return articles.map(article => generateSupportArticleObject(article));
}

// Mixins

export function relatedArticle({
  id = generateId(),
  title,
  categoryName = 'General',
  seoUrl,
}: {
  readonly id?: number;
  readonly title?: string;
  readonly categoryName?: string;
  readonly seoUrl?: string;
}): SupportRelatedArticle {
  return {
    id,
    title: title ?? `Related Article ${id}`,
    categoryName: categoryName ?? 'General',
    seoUrl: seoUrl ?? `related-article-${id}`,
  };
}
